<h1 class="my-6 text-center font-bold md:my-12">
  <div class="text-sm uppercase text-steel-70">{{ 'marketReports.header' | transloco }}</div>
  <div class="text-3xl md:text-4xl">{{ report.propertyDetails.streetAddress }}</div>
  <div class="uppercase">{{ report.propertyDetails.suburb }} {{ report.propertyDetails.state }} {{ report.propertyDetails.postcode }}</div>
</h1>

<div class="mb-8 items-start md:flex md:gap-16">
  <mat-card class="mat-elevation-z4 flex gap-4 p-4 md:flex-col md:items-center md:text-center" appearance="outlined">
    <rma-profile-avatar
      class="h-20 w-20 shrink-0 md:h-40 md:w-40"
      [name]="report.profile.fullName"
      [avatar]="report.profile.avatarImage"
      [backgroundColour]="report.profile.backgroundColour"
    />
    <div class="mt-2 md:mt-0">
      <div class="text-lg font-bold md:text-2xl">{{ report.profile.fullName }}</div>
      <div class="flex items-center justify-center gap-2">
        @if ((report.profile.agentCode && (report.profile.agentOverallStars ?? 0 > 0)) || (report.profile.agencyOverallStars ?? 0 > 0)) {
          <rma-star-rating-summary
            [overallStars]="report.profile.agentCode ? report.profile.agentOverallStars : report.profile.agencyOverallStars"
          />
        }
        @if (report.profile.totalReviewCount) {
          <div class="text-steel-70">
            {{ 'review.count' | transloco: { count: report.profile.totalReviewCount } }}
          </div>
        }
      </div>
      <rma-market-report-top-award [awards]="report.agentAwards ?? report.agencyAwards" />
    </div>

    @if (report.profile.email) {
      <a class="hidden w-full md:flex" [href]="'mailto:' + report.profile.email" mat-flat-button color="primary">
        {{ 'button.label.get-in-touch' | transloco }}
      </a>
    }
    @if (report.profile.contactNumber) {
      <a class="hidden w-full md:flex" [href]="'tel:' + report.profile.contactNumber" mat-button color="primary">
        {{ report.profile.contactNumber }}
      </a>
    }
  </mat-card>

  <div class="mt-8 md:mt-4">
    <div class="hidden whitespace-pre-wrap md:block">
      <ng-container *ngTemplateOutlet="messageContent" />
    </div>

    <rma-see-more-text class="text-center md:hidden">
      <ng-container *ngTemplateOutlet="messageContent" />
    </rma-see-more-text>

    <ng-template #messageContent>
      {{ report.customMessage?.trim()?.length ? report.customMessage : report.profile.bio }}
      <div class="mt-4 font-bold">
        {{ report.profile.fullName }} {{ report.profile.agentTitle ? '-' : '' }} {{ report.profile.agentTitle }}
      </div>
      @if (report.profile.fullName !== report.profile.agencyName) {
        <div class="font-bold">{{ report.profile.agencyName }}</div>
      }
    </ng-template>
  </div>
</div>
